import { Check } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export function BossAssignmentCell({
  selected,
  editable,
  playerName,
  bossName,
  className,
  onHover,
  onToggle,
}: {
  selected: boolean;
  editable: boolean;
  playerName: string;
  bossName: string;
  className?: string;
  onHover: () => void;
  onToggle: () => void;
}) {
  const stateLabel = selected ? "vald" : "inte vald";
  const content = (
    <>
      {selected && <Check className="size-4" aria-hidden />}
      <span className="sr-only">
        {playerName} är {stateLabel} för {bossName}
      </span>
    </>
  );

  return (
    <td
      className={cn("h-10 min-w-28 p-0 text-center", className)}
      onMouseEnter={onHover}
    >
      {editable ? (
        <button
          type="button"
          aria-pressed={selected}
          aria-label={`${playerName}, ${bossName}: ${stateLabel}`}
          className={cn(
            "flex h-10 w-full items-center justify-center outline-none transition-colors hover:bg-muted/60 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset",
            selected && "bg-primary/10 text-primary hover:bg-primary/15",
          )}
          onClick={onToggle}
        >
          {content}
        </button>
      ) : (
        <div
          className={cn(
            "flex h-10 w-full items-center justify-center",
            selected && "bg-primary/10 text-primary",
          )}
        >
          {content}
        </div>
      )}
    </td>
  );
}
